// extracted by mini-css-extract-plugin
export default {"TextInput":"FilesSearchBox-module__TextInput--LKpMn","Box":"FilesSearchBox-module__Box--Ye6rL"};